<ng-container *ngIf="vm$ | async as vm">
    <uni-buttons [isFlexEnd]="false">
        <ng-container *ngFor="let item of vm.items">
            <button
                type="button"
                [attr.active]="item.active || null"
                [disabled]="item.disabled"
                (click)="selectOption(item)"
            >
                {{item.label}}
            </button>
        </ng-container>
    </uni-buttons>
</ng-container>
